
import QrcodeVue from 'qrcode.vue'
import {DoccliService} from '../../../../providers/DoccliService.js';
const doccliService = new DoccliService();
import {AppService} from '../../../../providers/AppService.js';
const appService = new AppService();

import {SouscriptionService} from '../../../../providers/SouscriptionService.js';
const souscriptionService = new SouscriptionService();

import { minLength,maxLength,email } from 'vuelidate/lib/validators'

let msgServer;
export default {
    name: "ProgressScan",
     data () {
    return {
      tabs: null,
      text: 'chargement en cours...',
      showWait: true,
      message:'',
      dialogAriad: true,
      ifrmLoaded:true,
      offre:null,
      options:[],
      codeVendeur:'',
      optionsSelected:[],
      offreSelected:'',
      piecesToScan:[],
      token:null,
      callbackUrl:null,
      isDevicePC:false,      
      sdkwebScan:"",
      qrcodeSize: 200,
      sendLink: true,
      contactEmail:null,
      contactNumMobile:null,
      linkType : 'sdkWeb',
      loading : false,
      loadingSendLink : false,
      goback:null

    }
  },
  validations: {
    contactNumMobile: { minLength: minLength(10),maxLength: maxLength(10) },    
    contactEmail: { email }
  },
  computed: {
    mobileErrors () {
      const errors = []
      if (!this.$v.contactNumMobile.$dirty) return errors
      !this.$v.contactNumMobile.maxLength && errors.push('Numero à 10 chiffres')
      !this.$v.contactNumMobile.minLength && errors.push('Numero à 10 chiffres')
      return errors
    },
    emailErrors () {
      const errors = []
      //this.errorEmail="";
      if (!this.$v.contactEmail.$dirty) return errors
      !this.$v.contactEmail.email && errors.push('Adresse email invalide')
      //if(this.errorEmail != '') errors.push(this.errorEmail)
      return errors
    }
  },
  components: {
    QrcodeVue
  }, 
 
  beforeMount: function () {
    this.token = this.$root.token;
    this.callbackUrl = this.$root.callback;
    this.isDevicePC = this.$globalService.isDevicePC(this.$device);
    
  },
  mounted: function () {
   
    var sessionSouscription = this.$globalService.getSessionSouscription();
    if(this.token){      
      if(sessionSouscription == null || !sessionSouscription.doccli_id)  {    
        this.getDoccliByAccessToken();
      }else{
        if(this.$globalService.getSessionSouscription().sdkwebScan){
          if(this.isDevicePC)
            this.getQrcodeScan();
          else
            this.iframeScan();
        }else{
          this.getDoccliByAccessToken();
        }
      }
    }else{   
      if(this.$globalService.getSessionSouscription().offreChoisie.type == 'MOB')
        this.goback = "/souscription/offresmobile/choixoffreoption";
      else
        this.goback = "/souscription/offresbox/eligibilite/choixoffreoption";

      
      if(this.$globalService.getSessionSouscription().sdkwebScan){
        if(this.$root.user.type != 'TLV'){
          if(this.isDevicePC)
            this.getQrcodeScan();
          else
            this.iframeScan();
        }else
          this.sendLink = false;
      }else{
    
        this.offreSelected= sessionSouscription.offreChoisie.id;
        this.options = sessionSouscription.optionsChoisies;
        this.codeVendeur = this.$root.user.codevendeur;

        this.options.forEach(opt => {
          this.optionsSelected.push(opt.id);
        });

        this.piecesToScan = sessionSouscription.piecesToScan;
        
        this.getScan();

      }
    }
    if(this.$root.user.type == 'TLV')
      this.showWait = false;

    /*if(this.token){
      this.getDoccliByAccessToken();
    }else{
      var sessionSouscription = this.$globalService.getSessionSouscription();
    
      this.offreSelected= sessionSouscription.offreChoisie;
      this.options = sessionSouscription.optionsChoisies;
      this.codeVendeur = this.$root.user.codevendeur;

      this.options.forEach(opt => {
        this.optionsSelected.push(opt.id);
      });

      this.piecesToScan = sessionSouscription.piecesToScan;
      
      this.getScan();
    }*/
  },
  beforeDestroy() {
    // Make sure to close the connection with the events server
    // when the component is destroyed, or we'll have ghost connections!
    if(msgServer)
      msgServer.close();
  },

  methods: {
    confirmAnnuler: function(){
      this.dialogAriad = false;
      msgServer.close();
      if(!this.token){
        
        if(this.$globalService.getSessionSouscription().offreChoisie.type == 'MOB')
          this.$router.push({name: 'ChoixOffreOptionMobile'});
        else
        this.$router.push({name: 'ChoixOffreOption'});
      }
      else
        this.callback();
      

    },
    callback:function(){      
      this.$root.logoutToken();
      if(this.callbackUrl)
        window.location.href=this.callbackUrl;
      

      
    },
    annuler:async function(){
      await this.$dialog.confirm({
        text: "Etes vous certain de vouloir annuler le scan et l'analyse des documents en cours?",
        type:'warning',
        title: 'Alert',
        actions: {
          false: 'Non',
          true: {
            color: 'red',
            text: 'Oui',
            handle: () => {
              this.confirmAnnuler();
            }
          }
        }
      })
    },
    init: function(){
     

    },
    getDoccliByAccessToken: function(){
      
      this.loading = true;      
      this.$root.progress = true;
      doccliService.getDoccliByAccessToken(this.token).then(res => {
           
          if (res) {
            if (res.err != "error") {
              this.$globalService.setSessionSouscription('doccli_id',res.params.doccli_id);
              
              this.getSDkWebScan();
            }else{
              this.loading = false;
              this.$root.progress = false;
              this.dialogAriad = false;
              this.$dialog.error({
                text: res.err_msg,
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
            
            }
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$root.progress = false;
          this.$dialog.notify.error(this.$root.errorMessage, {
            position: "bottom-right",
            timeout: 5000,
          });
          return error;
        });
    },
    getScan: function(){
      
      this.loading = true;
      this.$root.progress = true;
      doccliService.getScan(this.piecesToScan,this.codeVendeur,this.offreSelected, this.$root.user.site,this.optionsSelected).then(res => {
          if (res) {
            if (res.err != "error") {
              this.$globalService.setSessionSouscription('doccli_id',res.params.doccli_id);
              this.getSDkWebScan();
            }else{
              this.loading = false;
              this.$root.progress = false;
              this.dialogAriad = false;
              this.$dialog.error({
                text: res.err_msg,
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
            
            }
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$root.progress = false;
          this.dialogAriad = false;
          this.$dialog.notify.error(this.$root.errorMessage, {
            position: "bottom-right",
            timeout: 5000,
          });
          return error;
        });
    },
    sendAriadNextLinkBySmsAndEmail: function(){
      var sessionSouscription = this.$globalService.getSessionSouscription();

      this.loadingSendLink = true;
      souscriptionService.sendAriadNextLinkBySmsAndEmail(this.linkType,sessionSouscription.sdkwebScan,this.contactEmail, this.contactNumMobile).then(res => {
           this.loadingSendLink = false;
          if (res) {
            if (res.err != "error") {
              this.sendLink = true;
              this.showWait = true;
              
              this.$dialog.notify.warning(res.err_msg, {
                position: "bottom-right",
                timeout: 5000,
              });
              this.serverSentEvent();
            }else{
              //this.dialogAriad = false;
              this.$dialog.error({
                text: res.err_msg,
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
            
            }
          }
        })
        .catch((error) => {
          this.loadingSendLink = false;
          //this.dialogAriad = false;
          this.$dialog.notify.error(this.$root.errorMessage, {
            position: "bottom-right",
            timeout: 5000,
          });
          return error;
        });
    },
    
    getQrcodeScan: function(){
      //récuperation dans la session
      var sessionSouscription = this.$globalService.getSessionSouscription();
      if(sessionSouscription != null && sessionSouscription.sdkwebScan){
        this.sdkwebScan = sessionSouscription.sdkwebScan;
        
       this.$dialog.warning({
         text: "Scanner le qrcode ci-contre avec votre appareil mobile afin d'uploader les documents",
         title: 'Upload des pièces justificatives',
         persistent: true
       });

           //***************************** PARTIE SSE */
           this.$sse(appService.getBaseUrl()+'/sse/sse_scan.php?idSouscription='+sessionSouscription.souscriptionId, { format: 'json' })
             .then(sse => {
               // Store SSE object at a higher scope
               msgServer = sse;
              this.$root.progress = false;
               //si statut progress ne fais rien 
               sse.subscribe('PROGRESS', () => {
                 this.message = 'TRAITEMENT EN COURS !!!';
                 

               });

               //si statut progress ne fais rien 
               sse.subscribe('FINISH', () => {
                 this.message = "ANALYSE DES DOCUMENTS EN COURS !!!";
                 msgServer.close();
                   //appel de la fonction checkDossier
                   var sessionSouscription = this.$globalService.getSessionSouscription();

                   doccliService.checkDossier(sessionSouscription.doccli_id).then(res => {                       
                     this.showWait = false;
                     if(res){
                       if (res.err !='error') {
                         const data = res.params.data;
                         this.$globalService.setSessionSouscription('resultCheckScan',data);
                         if(data.checkStatus == 'ERROR'){
                           //redirection vers liste erreurs scan
                           this.$router.push({name: 'RecapScanError'});
                         }else if(data.checkStatus == 'WARNING'){
                           //redirection vers liste erreurs scan
                           this.$router.push({name: 'RecapScanWarning'});
                         }else{
                           //redirect vers recap scan
                           if(this.token)
                             this.$router.push({name: 'RecapScanOkForToken'});
                           else
                             this.$router.push({name: 'RecapScanOk'});
                         }
                        
                                   
                       }else{
                         this.$dialog.error({
                           text: "Analyse impossible suite à une erreur technique",
                           title: 'Erreur',
                           persistent: false,
                           actions: {
                             false: 'Fermer'
                           }
                         })
                       
                       }
                     }
                   }).catch(error=>{
               
                         this.loading = false;
                         this.$root.progress = false;
                         this.$dialog.notify.error(this.$root.errorMessage, {
                                   position: 'bottom-right',
                                   timeout: 5000
                                 })
                       return error;
                     })
               });

               sse.subscribe('ERROR', () => {
                 this.showWait = false;
                 this.$dialog.error({
                   text: this.$root.errorMessage,
                   title: 'Erreur',
                   persistent: false,
                   actions: {
                     false: 'Fermer'
                   }
                 })
                 msgServer.close();
               });
           })
         .catch(err => {
          this.$root.progress = false;
             console.error('Failed to connect to server', err);
             this.$dialog.error({
               text: this.$root.errorMessage,
               title: 'Erreur',
               persistent: false,
               actions: {
                 false: 'Fermer'
               }
             })
         });

       //******************* FIN SSE */
      }else{
        this.$root.progress = false;
       this.$dialog.error({
         text: this.$root.errorMessage,
         title: 'Erreur',
         persistent: false,
         actions: {
           false: 'Fermer'
         }
       })
      }
     
   },
    
   serverSentEvent: function(){
     //récuperation dans la session
     var sessionSouscription = this.$globalService.getSessionSouscription();
     if(sessionSouscription != null && sessionSouscription.sdkwebScan){
       this.sdkwebScan = sessionSouscription.sdkwebScan;
       
     

          //***************************** PARTIE SSE */
          this.$sse(appService.getBaseUrl()+'/sse/sse_scan.php?idSouscription='+sessionSouscription.souscriptionId, { format: 'json' })
            .then(sse => {
              // Store SSE object at a higher scope
              msgServer = sse;
      
              //si statut progress ne fais rien 
              sse.subscribe('PROGRESS', () => {
                this.message = 'TRAITEMENT EN COURS !!!';
                

              });

              //si statut progress ne fais rien 
              sse.subscribe('FINISH', () => {
                this.message = "ANALYSE DES DOCUMENTS EN COURS !!!";
                msgServer.close();
                  //appel de la fonction checkDossier
                  var sessionSouscription = this.$globalService.getSessionSouscription();

                  doccliService.checkDossier(sessionSouscription.doccli_id).then(res => {                       
                    this.showWait = false;
                    if(res){
                      if (res.err !='error') {
                        const data = res.params.data;
                        this.$globalService.setSessionSouscription('resultCheckScan',data);
                        if(data.checkStatus == 'ERROR'){
                          //redirection vers liste erreurs scan
                          this.$router.push({name: 'RecapScanError'});
                        }else if(data.checkStatus == 'WARNING'){
                          //redirection vers liste erreurs scan
                          this.$router.push({name: 'RecapScanWarning'});
                        }else{
                          //redirect vers recap scan
                          if(this.token)
                            this.$router.push({name: 'RecapScanOkForToken'});
                          else
                            this.$router.push({name: 'RecapScanOk'});
                        }
                       
                                  
                      }else{
                        this.$dialog.error({
                          text: "Analyse impossible suite à une erreur technique",
                          title: 'Erreur',
                          persistent: false,
                          actions: {
                            false: 'Fermer'
                          }
                        })
                      
                      }
                    }
                  }).catch(error=>{
              
                        this.loading = false;
                        this.$root.progress = false;
                        this.$dialog.notify.error(this.$root.errorMessage, {
                                  position: 'bottom-right',
                                  timeout: 5000
                                })
                      return error;
                    })
              });

              sse.subscribe('ERROR', () => {
                this.showWait = false;
                this.$dialog.error({
                  text: this.$root.errorMessage,
                  title: 'Erreur',
                  persistent: false,
                  actions: {
                    false: 'Fermer'
                  }
                })
                msgServer.close();
              });
          })
        .catch(err => {
          
            console.error('Failed to connect to server', err);
            this.$dialog.error({
              text: this.$root.errorMessage,
              title: 'Erreur',
              persistent: false,
              actions: {
                false: 'Fermer'
              }
            })
        });

      //******************* FIN SSE */
     }else{
      this.$dialog.error({
        text: this.$root.errorMessage,
        title: 'Erreur',
        persistent: false,
        actions: {
          false: 'Fermer'
        }
      })
     }
    
  },
    iframeScan: function(){
            
            
            var sessionSouscription = this.$globalService.getSessionSouscription();
           
              var iframe = this.$refs.ifrm;
              iframe.src = sessionSouscription.sdkwebScan;
              this.dialogAriad = true;
              
                //***************************** PARTIE SSE */
                this.$sse(appService.getBaseUrl()+'/sse/sse_scan.php?idSouscription='+sessionSouscription.souscriptionId, { format: 'json' })
                  .then(sse => {
                    // Store SSE object at a higher scope
                    msgServer = sse;
                    this.$root.progress = false;
                    //si statut progress ne fais rien 
                    sse.subscribe('PROGRESS', () => {
                      this.message = 'TRAITEMENT EN COURS !!!';
                    });

                    //si statut progress ne fais rien 
                    sse.subscribe('FINISH', () => {
                      this.message = "ANALYSE EN COURS DES DOCUMENTS !!!";
                      msgServer.close();
                        //appel de la fonction checkDossier
                        var sessionSouscription = this.$globalService.getSessionSouscription();

                        doccliService.checkDossier(sessionSouscription.doccli_id).then(res => {                       
                          this.showWait = false;
                          if(res){
                            if (res.err !='error') {
                              const data = res.params.data;
                              this.$globalService.setSessionSouscription('resultCheckScan',data);
                              if(data.checkStatus == 'ERROR'){
                                //redirection vers liste erreurs scan
                                this.$router.push({name: 'RecapScanError'});
                              }else if(data.checkStatus == 'WARNING'){
                                //redirection vers liste erreurs scan
                                this.$router.push({name: 'RecapScanWarning'});
                              }else{
                                //redirect vers recap OK scan                               
                                if(this.token)
                                  this.$router.push({name: 'RecapScanOkForToken'});
                                else
                                  this.$router.push({name: 'RecapScanOk'});
                              }
                            
                                        
                            }else{
                              this.$dialog.error({
                                text: "Analyse impossible suite à une erreur technique",
                                title: 'Erreur',
                                persistent: false,
                                actions: {
                                  false: 'Fermer'
                                }
                              })
                            
                            }
                          }
                        }).catch(error=>{
                    
                              this.loading = false;
                              this.$root.progress = false;
                              this.$dialog.notify.error(this.$root.errorMessage, {
                                        position: 'bottom-right',
                                        timeout: 5000
                                      })
                            return error;
                          })
                    });

                    sse.subscribe('ERROR', () => {
                      this.showWait = false;
                      this.$dialog.error({
                        text: this.$root.errorMessage,
                        title: 'Erreur',
                        persistent: false,
                        actions: {
                          false: 'Fermer'
                        }
                      })
                      msgServer.close();
                    });
                })
              .catch(err => {
                this.$root.progress = false;
                  console.error('Failed to connect to server', err);
                  this.$dialog.error({
                    text: this.$root.errorMessage,
                    title: 'Erreur',
                    persistent: false,
                    actions: {
                      false: 'Fermer'
                    }
                  })
              });

            //******************* FIN SSE */
    },
    getSDkWebScan: function(){
      
      var sessionSouscription = this.$globalService.getSessionSouscription();
      

      doccliService.getSdkWebScan(sessionSouscription.doccli_id,this.codeVendeur,this.offreSelected, this.optionsSelected).then(res => { 
        this.loading = false;
        this.$root.progress = false;
        if(res){
          if (res.err !='error') {
            this.$globalService.setSessionSouscription('souscriptionId',res.params.souscriptionId);
            this.$globalService.setSessionSouscription('sdkwebScan',res.params.sdkwebScan);
            if(this.$root.user.type != 'TLV'){
              if(this.isDevicePC)
                this.getQrcodeScan();
              else
                this.iframeScan();
            }else
              this.sendLink = false;
            //window.location.href = sessionSouscription.sdkwebScan;
          
                       
          }else{
            this.dialogAriad = false;
            this.$dialog.error({
              text: res.err_msg,
              title: 'Erreur',
              persistent: false,
              actions: {
                false: 'Fermer'
              }
            })

            
          
          }
        }
      }).catch(error=>{
            this.dialogAriad = false;
            this.loading = false;
            this.$root.progress = false;
            this.$dialog.notify.error(this.$root.errorMessage, {
                      position: 'bottom-right',
                      timeout: 5000
                    })
          return error;

          
        })
    
       
      
    }
  }
}